/* eslint-disable */
export default {
  logging: '기록 중...',
  logCall: '통화 기록',
  editLog: '기록 편집',
  select: '일치하는 레코드 선택',
  OnHold: '대기 중',
  Ringing: '벨 울림',
  CallConnected: '통화 연결됨',
  unknownUser: '알 수 없는 사용자',
  unknownNumber: '익명',
  unavailable: '통화 불가능',
  viewDetails: '세부 정보 보기',
  addEntity: '새로 만들기',
  addLog: '기록',
  text: '텍스트',
  call: '전화',
  addContact: '연락처 추가',
  missedCall: '부재중 전화',
  inboundCall: '수신',
  outboundCall: '발신',
  from: '발신자',
  to: '수신자',
  hangup: '전화 끊기',
  accept: '응답',
  toVoicemail: '음성 사서함에 보내기',
  anonymous: '익명',
  mergeToConference: '진행 중인 통화와 병합',
  hold: '대기',
  unhold: '보류 해제',
  transfer: '전달',
  reject: '거부',
  switchCall: '이 앱으로 통화 전환',
  callSwitch: '통화 전환',
  comfirmContext:
    '현재 {displayName}님과 통화 중입니다. 이 디바이스에서 통화를 계속하시겠습니까?',
  comfirmCancelButton: '취소',
  comfirmOKButton: '전환',
  ignore: '무시',
  holdAndAnswer: '대기 후 응답',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"addContact"@#@ @source: @#@"Add Contact"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"accept"@#@ @source: @#@"Answer"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"unhold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"switchCall"@#@ @source: @#@"Switch Call to this app"@#@
// @key: @#@"callSwitch"@#@ @source: @#@"Call Switch"@#@
// @key: @#@"comfirmContext"@#@ @source: @#@"You're currently on an active call with {displayName}. Would you like to continue the call on this device?"@#@
// @key: @#@"comfirmCancelButton"@#@ @source: @#@"Cancel"@#@
// @key: @#@"comfirmOKButton"@#@ @source: @#@"Switch"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
